import moment from 'moment'

export const memberManagement = {
    id: '',
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    passwordRetype: '',
    departmentId: '',
    divisionId: '',
    role: '',
    headDeptId: '',
    headDeptName: '',
    headDeptEmail: '',
    isVerified: false,
    isVerifiedEmail: false,
    createdAt : moment().format('YYYY-MM-DD'),
}

// export const memberManagementDetail = {
//     id: '',
//     firstName: '',
//     lastName: '',
//     email: '',
//     departmentName: '',
//     isVerified: false,
//     isVerifiedEmail: false,
//     createdAt : moment().format('YYYY-MM-DD'),
// }